export default "__VITE_ASSET__CncYbOUs__"